import React from 'react';
import { Stack, Typography, useTheme } from "@mui/material";
import { LessonProgress } from "@models/LessonProgress";
import { useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { LessonProgressAccordion } from 'components/views/myTrainings/LessonProgressAccordion/LessonProgressAccordion';
import { Lesson } from "models/Lesson";
import { SimpleLessonComponent } from 'components/views/myTrainings/SimpleLessonComponent/SimpleLessonComponent';
import { SectionTitle } from './YourLessonsSection.styles';

export const YourLessonsSection = (props: { allProgresses: LessonProgress[], actualProgresses: LessonProgress[], lessons: Lesson[], isStatisticOfLoggedUser: boolean }) => {
    const [expanded, setExpanded] = useState<number | null>(null);
    const { t } = useTranslation();
    const theme = useTheme();

    const handleChange = (panel: number) => (event: React.SyntheticEvent) => {     
        if (expanded === panel) {
            setExpanded(null);
            return;
        }
        setExpanded(panel);
    };

    const notStartedAssignedLessons = useMemo(() => {
        return props.lessons.filter(lesson => !props.actualProgresses.find(lp => lp.lessonVersion.lessonId === lesson.id))
    }, [props.lessons, props.actualProgresses])


    return <Stack marginTop={theme.spacing(5)}>
        <SectionTitle marginBottom={theme.spacing(5)} variant="h5">
            {props.isStatisticOfLoggedUser ? t('myTrainings.yourLessons') : t('myTrainings.userLessons')}
        </SectionTitle>
        {props.actualProgresses.map((lp, index) => 
            <LessonProgressAccordion
                key={index}
                index={index}
                lp={lp}
                historicalProgresses={
                    props
                        .allProgresses
                        .filter(lessonProgress => lessonProgress.lessonVersion.lessonId === lp.lessonVersion.lessonId)
                        .sort((a, b) => b.createdAt.localeCompare(a.createdAt))
                }
                expanded={expanded}
                handleChange={handleChange}
            />        
        )}
        {notStartedAssignedLessons.map((lesson, index) => 
            <SimpleLessonComponent
                key={index}
                lessonName={lesson.name}
                index={index}
                maxPoints={lesson.totalScore}
                />
        )}
    </Stack>
}